exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box-card[data-v-8be2fb42] {\n  margin: 20px;\n}\n", ""]);

// exports
